import { axiosInstance } from '@/http-common'

/**
 * Add geofencing
 */
export async function addGeofencing(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.post('/api/v1/data/geofencing', data)
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

export async function editGeofencing(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.patch('/api/v1/data/geofencing', data)
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

export async function addGeofencingEvents(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.post('/api/v1/data/geofencing_events', data)
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

export async function editGeofencingEvents(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.patch('/api/v1/data/geofencing_events', data)
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}